import { render, staticRenderFns } from "./RaceItalia.vue?vue&type=template&id=60974c12&scoped=true&"
import script from "./RaceItalia.vue?vue&type=script&lang=js&"
export * from "./RaceItalia.vue?vue&type=script&lang=js&"
import style0 from "./RaceItalia.vue?vue&type=style&index=0&id=60974c12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60974c12",
  null
  
)

export default component.exports